import { organizationsBreadcrumbs } from '@/views/organizations/routeBreadcrumbs'

export const sessionsBreadcrumbs = [
  {
    label: 'My Sessions',
    toName: 'SessionsView',
    toQuery: { disable_redirect: true },
  },
]

// Use the portal breadcrumbs if they are not the last item in the breadcrumbs array
export const sessionPortalBreadcrumbs = [
  ...sessionsBreadcrumbs,
  {
    dynamicLabel: 'session',
    toName: 'SessionPortal',
    onlyShowIf: ({ session }) => {
      return !!session
    },
  },
]

export const sessionBreadcrumbs = [
  ...sessionsBreadcrumbs,
  {
    dynamicLabel: 'session',
    onlyShowIf: ({ session }) => {
      return !!session
    },
    toName: 'SessionDataView',
  },
]
